import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const CSSContainer = styled.div`
  display: flex;
  align-items: center;
  .description-input-label {
    /** conversion from a .css file */
    font-weight: 600;
    margin-right: ${pxToRem(10)};
    width: ${pxToRem(100)};
  }
`;
